import React, { Component } from 'react';



class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      message: '',
    }
  }

  render() {

    if(this.props.data){
      var message = this.props.data.contactmessage;
    }

    return (
      <section id="contact">
        <div className="row section-head">
          <div className="two columns header-col">
            <h1><span>Get In Touch.</span></h1>
          </div>
          <div className="ten columns">
            <p className="lead">{message}</p>
            <p  style={{fontSize:"18px"}}>Email: Kalejayesh20@gmail.com</p>
            <p style={{fontSize:"18px"}}>Mobile :9890417560 / 9403632205</p>
            <p style={{fontSize:"18px"}}>Address: Ahmednagar,Maharshtra,414601</p>
          </div>
        </div>

                </section>
    );
  }
}

export default Contact;
